/* 02 二代の物語（2026-10-02）：二代の落款。画面に入ったら印を順に押す（1回だけ。動きを減らす設定では最初から押してある）。 */
(() => {
  const init = (el) => {
    if (el.dataset.rakkanOn) return;
    el.dataset.rakkanOn = '1';
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches || !('IntersectionObserver' in window)) return;
    el.classList.add('is-armed');
    const io = new IntersectionObserver((es) => es.forEach((e) => {
      if (!e.isIntersecting) return;
      io.disconnect();
      el.classList.add('is-in');
    }), { threshold: .6, rootMargin: '0px 0px -6% 0px' });
    io.observe(el);
  };
  const run = () => document.querySelectorAll('[data-kz-rakkan]').forEach(init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run, { once: true }); else run();
  document.addEventListener('shopify:section:load', run);
})();
